/**
 * 视频分组功能
 * 实现双flickity-carousel切换功能：图片轮播和视频轮播
 */

// 立即暴露全局函数，确保onclick能够找到
window.toggleVideoGroupMode = function(videoOnly) {
  console.log("toggleVideoGroupMode called with:", videoOnly);
  
  // 获取两个轮播元素
  const imageCarousel = document.querySelector(".product__media-list--images");
  const videoCarousel = document.querySelector(".product__media-list--videos");
  
  console.log("Image carousel found:", !!imageCarousel);
  console.log("Video carousel found:", !!videoCarousel);
  
  if (!imageCarousel || !videoCarousel) {
    console.error("Carousels not found!");
    return;
  }

  // 获取切换按钮
  const allButton = document.querySelector(".product__media-group-button--all");
  const videoButton = document.querySelector(".product__media-group-button--video");

  console.log("All button found:", !!allButton);
  console.log("Video button found:", !!videoButton);

  if (allButton && videoButton) {
    if (videoOnly) {
      allButton.classList.remove("active");
      videoButton.classList.add("active");
      // 显示视频轮播，隐藏图片轮播
      imageCarousel.style.display = "none";
      videoCarousel.style.display = "block";
      console.log("Switched to video mode");
    } else {
      allButton.classList.add("active");
      videoButton.classList.remove("active");
      // 显示图片轮播，隐藏视频轮播
      imageCarousel.style.display = "block";
      videoCarousel.style.display = "none";
      console.log("Switched to image mode");
    }
  }

  // 活动按钮样式通过CSS类控制，无需设置内联样式

  // 刷新当前显示的Flickity实例
  const currentCarousel = videoOnly ? videoCarousel : imageCarousel;
  const flickityInstance = window.ThemeFlickity
    ? window.ThemeFlickity.data(currentCarousel)
    : null;
  
  if (flickityInstance) {
    flickityInstance.resize();
    // 如果切换到视频模式，自动选择第一个视频
    if (videoOnly) {
      flickityInstance.select(0);
    }
  }
};

document.addEventListener("DOMContentLoaded", function () {
  // Wait for Flickity to be available before initializing
  const initWhenReady = () => {
    if (window.ThemeFlickity) {
      initVideoGroupButtons();
      setupVideoGroupFilter();
      setupThumbnailClickHandler();
    } else {
      // Retry after a short delay
      setTimeout(initWhenReady, 100);
    }
  };

  initWhenReady();
});

/**
 * 设置缩略图点击处理程序
 * 当点击视频缩略图时切换到视频模式，点击图片缩略图时切换到图片模式
 */
function setupThumbnailClickHandler() {
  const thumbnailButtons = document.querySelectorAll(
    '.product__thumbnail-item[data-action="select"]'
  );

  if (!thumbnailButtons.length) return;

  thumbnailButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      const mediaId = this.getAttribute("data-media-id");
      
      // 调试：显示缩略图的HTML结构
      console.log("Thumbnail HTML:", this.innerHTML);
      
      // 检查是否点击的是视频缩略图 - 查找播放图标badge
      const playBadge = this.querySelector('.product__thumbnail-badge');
      console.log("Play badge found:", !!playBadge);
      
      if (playBadge) {
        console.log("Badge HTML:", playBadge.innerHTML);
      }
      
      const isVideoThumbnail = playBadge && (
        playBadge.innerHTML.includes('play-fill') ||
        playBadge.innerHTML.includes('play') ||
        playBadge.querySelector('svg') ||
        playBadge.querySelector('[class*="play"]')
      );
      
      console.log("Thumbnail clicked - Media ID:", mediaId, "Is video:", isVideoThumbnail);
      
      if (isVideoThumbnail && mediaId) {
        console.log("Video thumbnail clicked, switching to video mode");
        
        // 阻止默认的图片轮播行为
        e.preventDefault();
        e.stopPropagation();
        
        // 切换到视频模式
        window.toggleVideoGroupMode(true);
        
        // 在视频轮播中找到对应的视频并切换到它
        setTimeout(() => {
          const videoCarousel = document.querySelector(".product__media-list--videos");
          if (videoCarousel) {
            const videoMediaItems = videoCarousel.querySelectorAll(".product__media-item");
            console.log("Found video carousel with", videoMediaItems.length, "video items");
            
            let targetIndex = -1;
            videoMediaItems.forEach((item, index) => {
              const itemMediaId = item.getAttribute("data-media-id");
              console.log(`Video item ${index}: media-id = ${itemMediaId}`);
              if (itemMediaId === mediaId) {
                targetIndex = index;
                console.log(`Found matching video at index ${index}`);
              }
            });

            if (targetIndex >= 0) {
              // 使用Flickity API切换到对应的视频
              const flickityInstance = window.ThemeFlickity
                ? window.ThemeFlickity.data(videoCarousel)
                : null;
              
              if (flickityInstance) {
                console.log("Switching to video at index:", targetIndex);
                flickityInstance.select(targetIndex);
                
                // 自动播放视频
                setTimeout(() => {
                  const targetItem = videoMediaItems[targetIndex];
                  if (targetItem) {
                    console.log("Attempting to play video");
                    const videoElement = targetItem.querySelector("video");
                    const externalVideo = targetItem.querySelector("external-video");
                    const nativeVideo = targetItem.querySelector("native-video");

                    if (videoElement) {
                      console.log("Found video element, attempting to play");
                      videoElement.play().catch((e) => console.error("Video play error:", e));
                    } else if (externalVideo || nativeVideo) {
                      console.log("Found external/native video, clicking play button");
                      const playButton = (externalVideo || nativeVideo).querySelector(".video-wrapper__play-button");
                      if (playButton) {
                        playButton.click();
                      } else {
                        console.log("Play button not found");
                      }
                    } else {
                      console.log("No video elements found in target item");
                    }
                  } else {
                    console.log("Target item not found");
                  }
                }, 300);
              } else {
                console.error("Flickity instance not found for video carousel");
              }
            } else {
              console.error(`Video with media ID ${mediaId} not found in video carousel`);
            }
          } else {
            console.error("Video carousel not found");
          }
        }, 100);
      } else {
        // 如果点击的是图片缩略图，确保切换到图片模式
        console.log("Image thumbnail clicked, switching to image mode");
        window.toggleVideoGroupMode(false);
      }
    });
  });
}

function initVideoGroupButtons() {
  // 获取所有视频组按钮
  const videoGroupButtons = document.querySelectorAll(".video-group-button");

  if (!videoGroupButtons.length) return;

  videoGroupButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const mediaId = this.getAttribute("data-media-id");
      if (!mediaId) return;

      // 切换到视频分组模式
      window.toggleVideoGroupMode(true);

      // 在视频轮播中查找对应的媒体项
      const videoCarousel = document.querySelector(".product__media-list--videos");
      const videoMediaItems = videoCarousel.querySelectorAll(".product__media-item");
      
      let targetIndex = 0;
      videoMediaItems.forEach((item, index) => {
        if (item.getAttribute("data-media-id") === mediaId) {
          targetIndex = index;
        }
      });

      // 使用Flickity API切换到对应的视频
      const flickityInstance = window.ThemeFlickity
        ? window.ThemeFlickity.data(videoCarousel)
        : null;
      
      if (flickityInstance) {
        flickityInstance.select(targetIndex);

        // 如果是视频，触发播放
        setTimeout(() => {
          const targetItem = videoMediaItems[targetIndex];
          const videoElement = targetItem.querySelector("video");
          const externalVideo = targetItem.querySelector("external-video");
          const nativeVideo = targetItem.querySelector("native-video");

          if (videoElement) {
            videoElement
              .play()
              .catch((e) => console.error("Video play error:", e));
          } else if (externalVideo || nativeVideo) {
            const playButton = (externalVideo || nativeVideo).querySelector(
              ".video-wrapper__play-button"
            );
            if (playButton) {
              playButton.click();
            }
          }
        }, 100);
      }
    });
  });
}

/**
 * 设置视频分组过滤功能
 */
function setupVideoGroupFilter() {
  // 初始化时默认显示图片轮播
  window.toggleVideoGroupMode(false);
}
